import { IonText } from '@ionic/react';
import classNames from 'classnames';

type DqTextVariant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'body'
  | 'body-strong'
  | 'body-small'
  | 'body-strong-underlined-clickable'
  | 'chart'
  | 'label';

interface DqTextProps extends React.ComponentProps<typeof IonText> {
  variant?: DqTextVariant;
}

export const DqText: React.FC<DqTextProps> = ({ children, variant = 'body', ...props }) => {
  return (
    <IonText {...props} className={classNames(variant, props.className)}>
      {children}
    </IonText>
  );
};
